export var UserActivationVoStatus;
(function (UserActivationVoStatus) {
    UserActivationVoStatus["ACTIVATED"] = "ACTIVATED";
    UserActivationVoStatus["DISABLED_BY_ADMIN"] = "DISABLED_BY_ADMIN";
    UserActivationVoStatus["DISABLED_BY_TRIAL_EXPIRATION"] = "DISABLED_BY_TRIAL_EXPIRATION";
    UserActivationVoStatus["DISABLED_BY_SYSTEM"] = "DISABLED_BY_SYSTEM";
    UserActivationVoStatus["DISABLED_BY_BILLING_SYSTEM"] = "DISABLED_BY_BILLING_SYSTEM";
})(UserActivationVoStatus || (UserActivationVoStatus = {}));
//# sourceMappingURL=user-activation-vo-status.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/user/user-activation-vo-status.js
// module id = 398
// module chunks = 14